import React from "react";
import type { JSX } from "react"
import { forwardRef } from "react"

export type Props = Omit<React.JSX.IntrinsicElements['button'], 'loading'> & {
    loading?: boolean
}

const Button = forwardRef<HTMLButtonElement, Props>(
    ({ type = 'button', className: _class = '', loading, disabled, children, ...props }, ref) => (
        <button
            {...props}
            className={`btn no-animation ${_class}`}
            disabled={disabled || loading}
            type={type}
            ref={ref}
        >
            {loading ? <span className='loading loading-spinner' /> : children}
        </button>
    ),
)

export default Button
